module.exports = __webpack_public_path__ + "static/media/country_py.f941c8f2.webp";